module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"paren":{"open":"（","close":"）"}},"en":{"paren":{"open":" (","close":")"}}}')
  delete Component.options._Ctor
}
